import { lazy } from "react";
// Specialist Referrals Module
// Manages patient referrals to medical specialists

const SpecialistReferralsPage = lazy(() => import("./pages/SpecialistReferralsPage"));
const ReferralCreatePage = lazy(() => import("./pages/ReferralCreatePage"));
// Export routes for AppRouter
export const specialistReferralsRoutes = [
  {
    path: "/specialist-referrals",
    element: <SpecialistReferralsPage />,
  },
  {
    path: "/specialist-referrals/create",
    element: <ReferralCreatePage />,
  },
  {
    path: "/specialist-referrals/edit/:referralId",
    element: <ReferralCreatePage />,
  },
  // Alias de la generación anterior (pages/Tools/Apps/SpecialistReferals), aún
  // referenciados desde links y bookmarks viejos.
  {
    path: "/SpecialistReferralDashboard",
    element: <SpecialistReferralsPage />,
  },
  {
    path: "/SpecialistReferralForm",
    element: <ReferralCreatePage />,
  },
];

// Export components for external use
export { default as ReferralsTable } from "./components/ReferralsTable";

// Export utilities
export * from "./constants/referralOptions";
export * from "./services";
